const configuredApiUrl = (process.env.REACT_APP_API_BASE_URL || "").replace(/\/+$/, "");
const apiOrigin = configuredApiUrl.replace(/\/api$/i, "");

export const resolveMediaUrl = (path) => {
  if (!path) return "";
  if (/^(https?:|blob:|data:)/i.test(path)) return path;

  const normalizedPath = String(path).replace(/^\/+/, "");
  return apiOrigin ? `${apiOrigin}/${normalizedPath}` : `/${normalizedPath}`;
};

export const collectionValues = (value) => {
  if (Array.isArray(value)) return value;
  if (Array.isArray(value?.$values)) return value.$values;
  return [];
};
